export const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000AA';

interface ResolvePublicTurnstileSiteKeyOptions {
  envValue?: string | null;
  nodeEnv?: string | null;
}

export function resolvePublicTurnstileSiteKey(options: ResolvePublicTurnstileSiteKeyOptions): string | null {
  const envValue = options.envValue?.trim();
  if (envValue && envValue.length > 0) {
    return envValue;
  }

  return options.nodeEnv === 'production' ? null : TURNSTILE_TEST_SITE_KEY;
}

export function isClientTurnstileBypassEnabled(envValue?: string | null): boolean {
  return envValue?.trim() === 'true';
}

export function isCloudflareTestingSiteKey(siteKey?: string | null): boolean {
  return siteKey?.trim().startsWith('1x') ?? false;
}
